export default {
  runSingleVariantFilter(state, commit, filterId) {
    state.cardsFiltered.forEach(card => {
      let singleOptionResults = []

      // If no option is selected, return all available variants
      if (!state.variantFilters.selected[filterId].length)
        return (singleOptionResults = card.variants)

      card.variants.forEach(variant => {
        state.variantFilters.selected[filterId].forEach(option => {
          // Special case for primary filter with 'All ...'
          if (option === '') return (singleOptionResults = card.variants)
          let values =
            filterId.indexOf('size') > -1
              ? variant.skus.filter(sku => sku.stock > 0).map(sku => sku.size)
              : variant[filterId]
          if (values.includes(option)) singleOptionResults.push(variant)
        })
      })

      // Find only unique object in array - alternative approach for new Set(...) that doesn't work in IE11
      let uniqueStartingPoint = []
      let uniqueResults = singleOptionResults.filter(result => {
        if (!uniqueStartingPoint.includes(result.id)) {
          uniqueStartingPoint.push(result.id)
          return true
        } else {
          return false
        }
      })

      // Commit single filter result (only unique values)
      commit('setFilteredVariants', {
        id: card.id,
        variants: uniqueResults,
      })
    })
  },

  runAllSingleItemFilters(state, commit) {
    Object.keys(state.itemFilters.selected).forEach(filterKey => {
      this.runSingleItemFilter(state, commit, filterKey)
    })
  },

  // Run single filter and save results in state.itemFilters.results[filterId]
  runSingleItemFilter(state, commit, filterId) {
    let combinedFilterResult = []
    let length = state.itemFilters.selected[filterId].length

    // If no filter is set, the result equals all available cards for that filter
    if (length === 0) {
      combinedFilterResult = state.cards
    } else {
      // Loop over all options per filter
      state.itemFilters.selected[filterId].forEach(option => {
        let singleOptionResults = []

        // Result per single option is either the matching cards or all cards if option is not selected
        // Empty case only applies for primary filters (All ...)
        singleOptionResults =
          option !== ''
            ? state.cardsFiltered.filter(card => card.tags.includes(option))
            : state.cards

        // Options are additive
        // => add results per option to combined filter result if not included yet
        singleOptionResults.forEach(card => {
          if (!combinedFilterResult.includes(card)) {
            combinedFilterResult.push(card)
          }
        })
      })
    }

    // Commit single filter result
    commit('setItemResults', {
      id: filterId,
      value: combinedFilterResult,
    })
  },

  // Expects an array of arrays and returns all elements present in all arrays
  buildIntersection(payload) {
    return payload.reduce((p, c) => p.filter(e => c.includes(e)))
  },

  // Gather all single filter results in one array
  concatFilters(filters) {
    let concatedFilters = []
    Object.keys(filters).forEach(key => {
      concatedFilters.push(filters[key])
    })
    return concatedFilters
  },

  buildResults(state, commit) {
    let intersectedFilters = []

    if (Object.keys(state.itemFilters.results).length === 0) {
      // If no itemFilters are defined on the filter page, show all available cards
      intersectedFilters = state.cards
    } else {
      let concatenatedFilters = this.concatFilters(state.itemFilters.results)
      intersectedFilters = this.buildIntersection(concatenatedFilters)
    }

    // Single filters are subtractive
    // => determine intersection of all single filter results
    commit('setFilteredCards', JSON.parse(JSON.stringify(intersectedFilters)))
  },
}
